import React from "react";
import {
  Card,
  Timeline,
  Typography,
  Tag,
  Empty,
} from "antd";
import {
  CheckCircleFilled,
  EnvironmentOutlined,
  ClockCircleOutlined,
  CarOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

const StopTimeline = ({
  points = [],
}) => {
  if (!points.length) {
    return (
      <Card
        style={{
          marginBottom: 16,
          borderRadius: 8,
        }}
      >
        <Empty description="No delivery stops available." />
      </Card>
    );
  }

  

  const getStatus = (point) => {

    if (point.visit_status === "delivered")
        return "completed";

    if (point.is_current)
        return "current";

    if (point.visit_status === "arrived")
        return "arrived";

    return "pending";
};

  const getColor = (status) => {
    switch (status) {
      case "completed":
        return "green";

      case "arrived":
        return "orange";

      case "current":
        return "blue";

      default:
        return "gray";
    }
  };

  const getDot = (status) => {
  switch (status) {
    case "completed":
      return (
        <CheckCircleFilled
          style={{
            color: "#52c41a",
            fontSize: 18,
          }}
        />
      );

    case "arrived":
      return (
        <CarOutlined
          style={{
            color: "#fa8c16",
            fontSize: 18,
          }}
        />
      );

    case "current":
      return (
        <EnvironmentOutlined
          style={{
            color: "#1677ff",
            fontSize: 18,
          }}
        />
      );

    default:
      return (
        <ClockCircleOutlined
          style={{
            color: "#999",
            fontSize: 18,
          }}
        />
      );
  }
};

  return (
    <Card
      style={{
        borderRadius: 8,
      }}
      bodyStyle={{
        padding: 18,
      }}
    >
      <Title
        level={5}
        style={{
          marginBottom: 20,
        }}
      >
        Delivery Stops
      </Title>

      <Timeline
        items={points.map((point) => {
          const status = getStatus(point);

          return {
            color: getColor(status),

            dot: getDot(status),

            children: (
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent:
                      "space-between",
                    alignItems: "center",
                  }}
                >
                  <Text strong>
                    {point.sequence_no}.{" "}
                    {point.name}
                  </Text>

                  <Tag
                    color={getColor(status)}
                  >
                    {status.toUpperCase()}
                  </Tag>
                </div>

                <Text type="secondary">
                  {point.address}
                </Text>

                <br />

                <Text
                  type="secondary"
                  style={{
                    fontSize: 12,
                  }}
                >
                  Radius :{" "}
                  {point.radius_meters || 100} m
                </Text>
              </div>
            ),
          };
        })}
      />
    </Card>
  );
};

export default StopTimeline;